module.exports = __webpack_public_path__ + "img/background_pc.d7a3dc61.png";